import { render, staticRenderFns } from "./Spider.vue?vue&type=template&id=127c7b76&"
import script from "./Spider.vue?vue&type=script&lang=js&"
export * from "./Spider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports